import { Outlet } from 'react-router-dom';
import NeuralCanvasV2 from './ui/NeuralCanvasV2';

/**
 * PublicLayout — layout condiviso da tutte le pagine pubbliche.
 *
 * NeuralCanvasV2 viene montato UNA SOLA VOLTA qui e non si reinizializza
 * mai durante la navigazione tra /login, /register, /onboarding, ecc.
 * React Router renderizza le pagine figlie via <Outlet />, lasciando
 * il canvas intatto (nessun unmount → nessun reset dei nodi).
 */
const PublicLayout = () => (
    <div className="relative min-h-screen">
        {/* Canvas fisso — mai smontato durante la navigazione pubblica */}
        <div className="fixed inset-0 z-0 pointer-events-auto">
            <NeuralCanvasV2 />
        </div>

        {/* Pagina corrente (login / register / onboarding / ecc.) */}
        <div className="relative z-10 w-full min-h-screen">
            <Outlet />
        </div>
    </div>
);

export default PublicLayout;
